import { AvatarImage } from "@/public/images";
import Image from "next/image";
import { memo } from "react";

function AvatarChange({ profile, forms }) {
  return (
    <div className=" bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8">
      <div className="flex xs:flex-row flex-col gap-4 xs:gap-8 items-center">
        <div className="flex w-20">
          <div className="flex w-20 h-20 rounded-full bg-cover object-cover bg-greyscaleGON-200 items-center justify-center">
            <Image
              unoptimized
              alt={`avatar-${1}`}
              src={profile?.avatar_url ?? AvatarImage}
              className="w-auto h-auto bg-cover bg-center rounded-full"
              placeholder="blur"
              blurDataURL={AvatarImage?.blurDataURL}
              width={140}
              height={140}
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 p-2 w-full text-center xs:text-start">
          <p className="text-greyscaleGON-600 p1-medium sm:h6-medium capitalize whitespace-nowrap truncate ">
            {profile?.username}
          </p>
          <p className="text-primaryGON-400 text-xs sm:text-button-medium capitalize whitespace-nowrap truncate ">
            {profile?.mitra_level < 5
              ? profile?.name_store
              : profile?.telephone ?? "-"}
          </p>
        </div>
      </div>
    </div>
  );
}

export default memo(AvatarChange);
